import * as Effects from 'redux-saga/effects'
import { all, call, put, take } from 'redux-saga/effects'
import { IntegrationAction } from '../../reducers/airbnb/actionNames'
import fetchActionsName, { ActionNames } from '../../utils/FetchActionsName'
import { callFetch } from '../../actions/fetch'
import fetchConfiguration from '../../models/Integration/fetchConfiguration'

function* getConfiguration(action) {
  try {
    const actionNames = fetchActionsName(
      ActionNames.FetchAirbnbRoomConfiguration,
    )
    const [{ service }] = yield all([
      take(actionNames.output),
      put(callFetch(actionNames.input, actionNames.output, fetchConfiguration)),
    ])

    const configuration = yield call(service, action.payload)

    yield Effects.put({
      type: IntegrationAction.RoomConfigurationAccepted,
      payload: { ...configuration, id_room: action.payload },
    })
  } catch (e) {
    yield Effects.put({
      type: IntegrationAction.ToggleConfigurationLoading,
      payload: false,
    })
    console.error(e)
  }
}

export default function*() {
  yield Effects.takeLatest(
    IntegrationAction.FetchRoomConfiguration,
    getConfiguration,
  )
}
